module.exports = __webpack_public_path__ + "ab348296a596c0f7fc57419462923f54.svg";